// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3ce82069","453":"25c84dc6","455":"283c0942","977":"3fd48da1"}[chunkId] + ".chunk.js";
};